export default __webpack_public_path__ + "static/media/Middlemarch Capital seeks co-investment partners for fintech deals _ Debtwire.f677d552.pdf";